var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-set"},[(!_vm.user)?[_c('router-view')]:[_c('the-header'),_c('div',{staticClass:"d-flex flex-wrap",staticStyle:{"height":"100vh"}},[_c('the-side-nav'),_c('div',{staticClass:"main-content",class:{ active: _vm.sideNav }},[_c('router-view')],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }